import axios from 'axios'

export const getResourceById = ({ resourceId }) => {
  return axios.get(`/post/published/${resourceId}`)
}

export const getAllResources = () => {
  return axios.get('/post/all-published')
}

export const getFavoriteResources = () => {
  return axios.get('/favorite/post')
}

export const addFavoriteResource = ({ resourceId }) => {
  return axios.post('/favorite/post', { id: resourceId })
}

export const deleteFavoriteResource = ({ resourceId }) => {
  return axios.delete(`favorite/post?id=${resourceId}`)
}

export const downloadResource = ({ resourceId }) => {
  return axios.post(`post/download/${resourceId}`)
}

export const addResourceViewCount = ({ resourceId }) => {
  return axios.put(`/post/add-view-count/${resourceId}`)
}

export const searchResources = ({ query, categoryName }) => {
  return axios.get(`/post/post-search`, {
    params: {
      query: [query],
      categoryName: categoryName,
    },
  })
}

export const searchAutocompleteResources = ({ query, categoryName }) => {
  return axios.get(`/post/autocomplete`, {
    params: {
      query: [query],
      categoryName: categoryName,
    },
  })
}
